import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const dt = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "");

export function GraceBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [lic, setLic] = useState(null);
  useEffect(() => {
    if (user?.role !== "client") { setLic(null); return; }
    api.get("/license/me").then(r => setLic(r.data)).catch(() => setLic(null));
  }, [user, pathname]); // eslint-disable-line
  if (!lic || lic.effective !== "grace" || pathname.startsWith("/subscription")) return null;
  return (
    <div data-testid="grace-banner" className="sticky top-0 z-50 bg-amber-500 text-zinc-950 print:hidden">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:text-sm">
        <AlertTriangle size={16} className="shrink-0" />
        <span className="font-semibold">Grace period — read only.</span>
        <span className="flex-1 min-w-[12rem]">Your {lic.plan_name} plan expired on {dt(lic.expiry_date)}. You can view data for <b data-testid="grace-days-left">{lic.days_left}</b> more day{lic.days_left === 1 ? "" : "s"} but cannot add or edit anything.</span>
        <Link to="/subscription" data-testid="grace-recharge-link" className="bg-zinc-950 text-white px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider hover:bg-zinc-800">Recharge now</Link>
      </div>
    </div>
  );
}
